<highcharts-chart [Highcharts]="Highcharts" [options]="options" #chartComp style="width: 100%; height: 350px; display: block;"></highcharts-chart>
